import { render, staticRenderFns } from "./storyDetail.vue?vue&type=template&id=2ac8455e&scoped=true"
import script from "./storyDetail.vue?vue&type=script&lang=js"
export * from "./storyDetail.vue?vue&type=script&lang=js"
import style0 from "./storyDetail.vue?vue&type=style&index=0&id=2ac8455e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac8455e",
  null
  
)

export default component.exports